/*
 * Copyright (c) 2025 NoorWays. All rights reserved.
 * Licensed under the terms specified in the LICENSE.txt file.
 */

import appConfig from './appConfig'

/**
 * Application settings adapter for compatibility with OpenAPI generated code
 * This file provides the expected interface for auto-generated API clients
 * while using the actual appConfig internally.
 */
const appSettings = {
  /**
   * Backend API URL - maps to appConfig.apiBaseUrl
   */
  get BACKEND_URL(): string {
    return appConfig.apiBaseUrl
  }
}

export default appSettings
